// Icons for the benefit guides, taken from Norma (@remote-com/norma, Outline style) as part of the
// rebrand (MAWEB-1095). Every icon is a plain SVG that uses `currentColor`, so the colour comes
// from the CSS `color` of whatever wraps it.
//
// To use another Norma icon:
//   1. node panda/scripts/norma-icon-to-svg.mjs <norma dist/icons dir> IconV2OutlineHeart
//      (writes assets/norma-icons/heart.svg)
//   2. import it below and add it to `normaIcons`
//   3. point a table key (`tableIconNames`) or a CMS image (`cmsIconReplacements`) at it
import CalendarDatesIcon from './assets/norma-icons/calendar-dates.svg';
import DollarSignIcon from './assets/norma-icons/dollar-sign.svg';
import FileCheckIcon from './assets/norma-icons/file-check.svg';
import FileTextIcon from './assets/norma-icons/file-text.svg';
import HeartIcon from './assets/norma-icons/heart.svg';
import InfoIcon from './assets/norma-icons/info.svg';
import MailIcon from './assets/norma-icons/mail.svg';
import PieChartIcon from './assets/norma-icons/pie-chart.svg';
import ShieldCheckIcon from './assets/norma-icons/shield-check.svg';
import StarIcon from './assets/norma-icons/star.svg';
import TimesFullIcon from './assets/norma-icons/times-full.svg';
import TrophyIcon from './assets/norma-icons/trophy.svg';
import VerticalNodesIcon from './assets/norma-icons/vertical-nodes.svg';

export const normaIcons = {
  'calendar-dates': CalendarDatesIcon,
  'dollar-sign': DollarSignIcon,
  'file-check': FileCheckIcon,
  'file-text': FileTextIcon,
  heart: HeartIcon,
  info: InfoIcon,
  mail: MailIcon,
  'pie-chart': PieChartIcon,
  'shield-check': ShieldCheckIcon,
  star: StarIcon,
  'times-full': TimesFullIcon,
  trophy: TrophyIcon,
  'vertical-nodes': VerticalNodesIcon,
};

// The icon keys an editor can pick in the table slices (first_icon … fourth_icon).
export const tableIconNames = {
  paper: 'file-text',
  prize: 'trophy',
  shield: 'shield-check',
  star: 'star',
  usd: 'dollar-sign',
};

// Prismic images in the "benefits_additional" slice that render as a Norma icon instead. Keyed by
// the asset id, the uuid in front of the file name in the image URL
// (…/all-remote-content/<asset id>_<file name>.svg). Images that are not listed keep rendering
// from the CMS, so adding a replacement is one line here.
export const cmsIconReplacements = {
  '0c674c31-b569-455a-b7ad-ac79c172e9a4': 'file-check', // benefits-white-check-list.svg
  '487d6e3f-c172-4e60-aa17-227177866b5c': 'mail', // benefits-white-mail.svg
  '7847da9f-f7b1-4e48-aed4-ce7fe16423f3': 'heart', // benefits-white-heart.svg
  '5aaaa347-5359-41e7-92be-9529402a1397': 'star', // icon-star.svg
  'e897c0a5-5349-43d5-b793-87b12b4110a5': 'dollar-sign', // Icon (8).svg
  '1c5fb51f-213c-4dc5-a194-24e6b39e7232': 'vertical-nodes', // Options svg icon.svg
  'eab97f51-07e6-4cc8-adb9-edda54dae491': 'pie-chart', // Pie svg icon.svg
};

const ASSET_ID = /([0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12})_/i;

export function getCmsIconReplacement(url) {
  const assetId = url?.match(ASSET_ID)?.[1]?.toLowerCase();
  return normaIcons[cmsIconReplacements[assetId]] ?? null;
}
